var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "be-dev-client" }, [
    _c("div", { staticClass: "title" }, [_vm._v("DevClient")]),
    _vm._v(" "),
    _vm.clientId
      ? _c("div", { staticClass: "client-id" }, [_vm._v(_vm._s(_vm.clientId))])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "connection-status" },
      [
        _vm.isConnected
          ? [
              _c("div", { staticClass: "status-dot connected" }),
              _vm._v(" "),
              _c("div", { staticClass: "status-text" }, [_vm._v("已连接")]),
              _vm._v(" "),
              _c(
                "AsyncButton",
                { attrs: { title: "断开连接" }, on: { click: _vm.disconnect } },
                [
                  _c("VIcon", { attrs: { icon: "mdi-stop", size: 14 } }),
                  _vm._v("\n        断开连接\n      "),
                ],
                1
              ),
            ]
          : [
              _c("div", { staticClass: "status-dot disconnected" }),
              _vm._v(" "),
              _c("div", { staticClass: "status-text" }, [_vm._v("未连接")]),
              _vm._v(" "),
              _c(
                "AsyncButton",
                { attrs: { title: "连接" }, on: { click: _vm.connect } },
                [
                  _c("VIcon", { attrs: { icon: "mdi-play", size: 14 } }),
                  _vm._v("\n        连接\n      "),
                ],
                1
              ),
            ],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }